import React, { Component } from 'react';
import Header from '../header';
import Footer from '../footer';
import './index.less';

/**
 * 联系我们
 */
class Contact extends Component {
    render() {
        return (
            <div className="contact">
                <Header />
                <div className="contact__wrapper">
                    联系我们
                </div>
                <Footer />
            </div>
        );
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/cmps/contact/index.js